export enum HelpTypes {

    messageBox = 'MESSAGE_BOX',
    sideDialog = 'SIDE_DIALOG',
    link = 'LINK'

}
